export default __webpack_public_path__ + "static/media/critical-illness.843e33ed.svg";